export default {
	statusNotificationList: [],
	statusCount: [],
  quoteStatuses: '',
  whatsappTemplates: []
}
